import { createIcon } from '@chakra-ui/react';

export const MbeFrFlag = createIcon({
  displayName: 'MbeFrFlag',
  viewBox: '0 0 64 64',
  path: (
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4 4)">
        <mask fill="#fff" id="59ebzuvw1b">
          <use xlinkHref="#3wsxaiia3a" />
        </mask>
        <path
          d="M28 1.412C13.34 1.412 1.412 13.339 1.412 28c0 14.66 11.927 26.588 26.588 26.588 14.66 0 26.588-11.927 26.588-26.588C54.588 13.34 42.661 1.412 28 1.412M28 56C12.56 56 0 43.44 0 28 0 12.56 12.56 0 28 0s28 12.56 28 28c0 15.439-12.56 28-28 28"
          fill="#E2001A"
          mask="url(#59ebzuvw1b)"
        />
      </g>
      <path
        d="M32 19.479c6.915 0 12.522 5.606 12.522 12.521 0 6.915-5.607 12.521-12.522 12.521s-12.522-5.606-12.522-12.52c0-6.916 5.607-12.522 12.522-12.522"
        fill="#E6E6E6"
      />
      <path
        d="M44.521 32c0-5.384-3.398-9.974-8.166-11.743v23.486c4.768-1.77 8.166-6.36 8.166-11.743"
        fill="#E2001A"
      />
      <path
        d="M19.479 32c0 5.384 3.398 9.974 8.166 11.743V20.257c-4.768 1.77-8.166 6.36-8.166 11.743"
        fill="#00489A"
      />
    </g>
  ),
});
